/* sk-snocks.js — Snocks-Arrangement PDP (Philipp 30.10.2026, Test nur Mottenspray).
   <sk-snocks-bundle>: Gesamtpreis bei Variantenwahl neu rechnen, alle Artikel mit EINEM Klick in den Warenkorb.
   Warenkorb wie sk-pdp.js: CartLinesUpdateEvent (@shopify/events) → sk-cart-bridge öffnet den Drawer; dann /cart/add.js (items[]).
   Philipp 31.10.: Bundle −10 % – data-discount + data-code nur, wenn der Shopify-Rabatt (MOTTENBUNDLE10) auf alle Bundle-Produkte wirkt.
   Der Button setzt den Code selbst (/cart/update.js discount=…), Kunde tippt nichts ein. Shopify rundet je Position ab → hier ebenso.
   Erkennungsmerkmal für andere Skripte (z. B. Mengen-Upsell-Popup): Line-Property _sk_bundle (nicht leer) und Event-Detail source='bundle'.
   Philipp 31.10.: Upsell-/Bundle-Messung – _sk_bundle = Bundle-ID (data-bundle-id der Karte, sonst '1'); anonymer Tageszähler
   „Bundle gezeigt“ (IntersectionObserver, 1× je Bundle und Seite) + „Bundle-Klick“ per sendBeacon an das ERP
   (/public/upsell-events, keine IDs/Cookies; Auswertung ERP → Content → Upsell-Messung).
   31.10. Slider auf allen PDPs: jede Karte ist ein eigenes <sk-snocks-bundle data-bundle-id> mit eigenem Code (BUNDLE10-…,
   bundle-sync.mjs); <sk-snocks-bundles> = Slider (scroll-snap, Pfeile, Punkte, Zähler). Event-Detail zusätzlich bundleId. */
/* Gemeinsamer Zähler (identisch in sk-upsell.js) – localStorage sk_track_test=1 markiert Testaufrufe. */
window.skTrack = window.skTrack || function (o) {
  try {
    if (localStorage.getItem('sk_track_test') === '1') o.x = 'smoke-test';
  } catch (_) {}
  try {
    try { if (window.skIntern) o.i = 1; } catch (_) {}
    const u = 'https://erp-api-289183413262.europe-west1.run.app/public/upsell-events', b = JSON.stringify(o);
    if (!(navigator.sendBeacon && navigator.sendBeacon(u, b))) fetch(u, { method: 'POST', body: b, keepalive: true, mode: 'no-cors' }).catch(() => {});
  } catch (_) {}
};
class SkSnocksBundle extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;
    this.addEventListener('change', (e) => {
      if (!(e.target instanceof Element) || !e.target.matches('[data-sk-sn-select]')) return;
      e.stopPropagation(); /* nicht an <sk-product> (Variantenwahl des Hauptprodukts) weiterreichen */
      this.update();
    });
    this.addEventListener('click', (e) => {
      const b = e.target instanceof Element ? e.target.closest('[data-sk-sn-add]') : null;
      if (b) this.add(b);
    });
    /* 31.10. Slider: nach Variantenwechsel oben ersetzt sk-pdp.js den Slider-Inhalt ([data-sk-swap]) → neue Elemente rechnen selbst */
    this.update();
    this.observe();
  }

  pid() {
    const h = this.dataset.productId ? this : this.closest('[data-product-id]');
    return (h && h.dataset.productId) || '';
  }

  bundleId(el) {
    const c = el && el.closest ? el.closest('[data-bundle-id]') : null;
    return (c && this.contains(c) && c.dataset.bundleId) || this.dataset.bundleId || '';
  }

  /* „Bundle gezeigt“: je Bundle-Karte (data-bundle-id) bzw. Block 1× pro Seitenaufruf, sobald ≥ 50 % sichtbar */
  observe() {
    if (!('IntersectionObserver' in window) || !this.pid()) return;
    const seen = (window.__skBundleSeen = window.__skBundleSeen || {});
    const io = new IntersectionObserver((es) => {
      for (const e of es) {
        if (!e.isIntersecting) continue;
        const b = this.bundleId(e.target);
        io.unobserve(e.target);
        if (seen[b || '-']) continue;
        seen[b || '-'] = 1;
        window.skTrack({ k: 'bundle', e: 'shown', p: this.pid(), b: b || null });
      }
    }, { threshold: 0.5 });
    const cards = Array.from(this.querySelectorAll('[data-bundle-id]'));
    (cards.length ? cards : [this]).forEach((x) => io.observe(x));
  }

  fmt(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(cents / 100);
    } catch (_) {
      return (cents / 100).toFixed(2);
    }
  }

  items() {
    return Array.from(this.querySelectorAll('[data-sk-sn-item]'));
  }

  update() {
    let sum = 0;
    let off = 0;
    let ok = true;
    const disc = Number(this.dataset.discount) || 0;
    for (const it of this.items()) {
      const sel = it.querySelector('[data-sk-sn-select]');
      if (sel) {
        const o = sel.selectedOptions[0];
        if (o) {
          it.dataset.variantId = o.value;
          it.dataset.price = o.dataset.price;
          it.dataset.available = String(!o.disabled);
          const pr = it.querySelector('[data-sk-sn-price]');
          const un = it.querySelector('[data-sk-sn-unit]');
          if (pr) pr.textContent = o.dataset.priceText || this.fmt(Number(o.dataset.price));
          if (un) {
            /* Perf 31.10.: Grundpreis je Option aus Rohdaten (data-um/data-up) über window.skUnitPrice – Format wie sk-unit-price-text */
            const U = window.skUnitPrice;
            if (U) {
              let t = '';
              try {
                if (o.dataset.um && o.dataset.up) { const q = U.parts(JSON.parse(o.dataset.um), Number(o.dataset.up), o.textContent.trim()); if (q) t = `${q.qty} · ${q.amount} / ${q.measure}`; }
              } catch (_) {}
              if (o.dataset.um || !t) un.textContent = t;
            }
          }
        }
      }
      sum += Number(it.dataset.price) || 0;
      if (disc > 0) off += Math.floor(((Number(it.dataset.price) || 0) * disc) / 100);
      if (it.dataset.available === 'false') ok = false;
    }
    const total = sum - off;
    const t = this.querySelector('[data-sk-sn-total]');
    const c = this.querySelector('[data-sk-sn-compare]');
    const s = this.querySelector('[data-sk-sn-save]');
    if (t) t.textContent = this.fmt(total);
    /* Philipp 31.10.: über der Gratisversand-Grenze (nach Rabatt, Land aus sk-shipping-zones) „versandkostenfrei“ */
    const thr = Number(this.dataset.freeThreshold) || 0;
    const free = thr > 0 && total >= thr;
    const sf = this.querySelector('[data-sk-sn-ship-free]'), sp = this.querySelector('[data-sk-sn-ship-paid]');
    if (sf) sf.hidden = !free;
    if (sp) sp.hidden = free;
    if (c) { c.textContent = this.fmt(sum); c.hidden = !(disc > 0); }
    if (s && s.dataset.tpl) s.textContent = s.dataset.tpl.replace('[amount]', this.fmt(sum - total));
    const btn = this.querySelector('[data-sk-sn-add]');
    if (btn) btn.disabled = !ok;
  }

  async add(btn) {
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    const msg = this.querySelector('[data-sk-sn-msg]');
    if (msg) msg.hidden = true;
    const bid = this.bundleId(btn);
    const host = this.closest('sk-snocks-bundles');
    const msgErr = host?.dataset.err || this.dataset.err || '', msgNo = host?.dataset.nodisc || this.dataset.nodisc || '';
    /* 31.10.: _sk_bundle_code/_sk_bundle_n für assets/sk-bundle-guard.js (Code fällt weg, sobald der Warenkorb nicht mehr exakt dem Bundle entspricht) */
    const n = this.items().length;
    const lines = this.items().map((it) => ({ id: Number(it.dataset.variantId), quantity: 1, properties: Object.assign({ _sk_bundle: bid || '1', _sk_bundle_n: String(n) }, this.dataset.code ? { _sk_bundle_code: this.dataset.code } : {}) }));
    const disc = Number(this.dataset.discount) || 0;
    window.skTrack({ k: 'bundle', e: 'add', p: this.pid(), b: bid || null, v: this.items().reduce((a, it) => { const pr = Number(it.dataset.price) || 0; return a + pr - (disc > 0 ? Math.floor((pr * disc) / 100) : 0); }, 0) });
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((x) => x.dataset.sectionId);
    let ev = null;
    let deferred = null;
    try {
      const m = await import('@shopify/events');
      ev = m.CartLinesUpdateEvent;
      deferred = ev.createPromise();
      this.dispatchEvent(new ev({ action: 'add', context: 'product', lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: 1 })), promise: deferred.promise }));
    } catch (_) { /* ohne Events-Modul nur Warenkorb-API */ }
    const url = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
    const body = { items: lines };
    if (sectionIds.length) body.sections = sectionIds.join(',');
    try {
      const post = () => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
      let r = await post();
      if (r.status === 429 || r.status >= 500) { await new Promise((ok) => setTimeout(ok, 1500)); r = await post(); }
      const data = await r.json().catch(() => ({}));
      const failed = !r.ok || data.status;
      const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json()).catch(() => ({ items: [], item_count: 0 }));
      let cart = await getCart();
      const code = this.dataset.code;
      if (!failed && code) {
        /* Bundle-Rabatt setzen; vorhandene Codes behalten (nicht kombinierbare wählt Shopify selbst → kein Doppelrabatt) */
        const codes = (cart.discount_codes || []).map((d) => d.code).filter((c) => c && c.toUpperCase() !== code.toUpperCase());
        codes.push(code);
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) }).catch(() => {});
        cart = await getCart();
        const mine = (cart.discount_codes || []).find((d) => d.code.toUpperCase() === code.toUpperCase());
        const other = (cart.discount_codes || []).some((d) => d.applicable && d !== mine);
        if (mine && !mine.applicable && !other && msg) { msg.textContent = msgNo; msg.hidden = false; }
      }
      if (failed && msg) { msg.textContent = data.description || data.message || msgErr; msg.hidden = false; }
      if (deferred && ev) {
        deferred.resolve({ cart: ev.createCartFromAjaxResponse(cart), detail: { didError: !!failed, items: cart.items, source: 'bundle', skBundle: true, bundleId: bid || '1', itemCount: lines.length, sections: data.sections } });
      } else if (!failed) {
        window.location.href = '/cart';
      }
    } catch (x) {
      deferred?.reject(x);
      if (msg) { msg.textContent = msgErr; msg.hidden = false; }
    } finally {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
    }
  }
}
if (!customElements.get('sk-snocks-bundle')) customElements.define('sk-snocks-bundle', SkSnocksBundle);

/* Slider: mobil wischen (scroll-snap, nächste Karte angeschnitten), Pfeile, Punkte, „1 von 3“. Kein Layout-JS → kein CLS. */
class SkSnocksBundles extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;
    this.idx = 0;
    this.addEventListener('click', (e) => {
      const t = e.target instanceof Element ? e.target : null;
      if (t?.closest('[data-sk-sn-prev]')) { this.loadRest(); this.go(this.idx - 1); }
      else if (t?.closest('[data-sk-sn-next]')) { this.loadRest(); this.go(this.idx + 1); }
    });
    this.addEventListener('keydown', (e) => {
      if (!(e.target instanceof Element) || !e.target.matches('[data-sk-sn-track]')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.idx - 1); }
    });
    this.bind();
    /* Variantenwechsel oben: Inhalt neu → Position wiederherstellen */
    document.addEventListener('sk:variant-rendered', () => { const i = this.idx; this.bind(); this.go(i, true); });
  }
  slides() { return Array.from(this.querySelectorAll('[data-sk-sn-slide]')); }
  label() {
    const sl = this.slides();
    const of = this.dataset.of || '/';
    sl.forEach((s, i) => s.setAttribute('aria-label', `${i + 1} ${of} ${sl.length}`));
  }
  bind() {
    const track = this.querySelector('[data-sk-sn-track]');
    if (!track || track === this.track) return;
    this.track = track;
    this._rest = false;
    this.label();
    let raf = 0;
    track.addEventListener('scroll', () => { this.loadRest(); cancelAnimationFrame(raf); raf = requestAnimationFrame(() => this.sync()); }, { passive: true });
    /* Perf 31.10.: Bundles 2–3 nachladen, sobald der Slider in die Nähe des Viewports kommt (oder beim ersten Wischen/Pfeil) */
    if (this.querySelector('[data-sk-sn-ph]')) {
      if ('IntersectionObserver' in window) {
        this._io?.disconnect();
        this._io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { this._io.disconnect(); this.loadRest(); } }, { rootMargin: '400px 0px' });
        this._io.observe(this);
      } else this.loadRest();
      /* zusätzlich im Leerlauf kurz nach dem Laden – dann ist alles da, bevor jemand direkt zum Slider springt (kein sichtbarer Sprung) */
      const idle = window.requestIdleCallback ? (f) => window.requestIdleCallback(f, { timeout: 4000 }) : (f) => setTimeout(f, 2500);
      setTimeout(() => idle(() => this.loadRest()), 1500);
    }
    this.sync();
  }
  loadRest() {
    if (this._rest || !this.dataset.restUrl || !this.querySelector('[data-sk-sn-ph]')) return;
    this._rest = true;
    const vid = this.closest('sk-product')?.dataset.variantId;
    const url = this.dataset.restUrl + (vid ? '&variant=' + vid : '');
    fetch(url).then((r) => (r.ok ? r.text() : '')).then((html) => {
      const doc = new DOMParser().parseFromString(html || '', 'text/html');
      this.querySelectorAll('[data-sk-sn-ph]').forEach((ph) => {
        const fresh = doc.querySelector(`[data-sk-sn-rest] [data-sk-sn-idx="${ph.dataset.skSnPh}"]`);
        if (fresh) ph.replaceWith(document.importNode(fresh, true));
        else { ph.remove(); this.querySelector('[data-sk-sn-dot]:last-child')?.remove(); }
      });
      this.label();
      this.sync();
    }).catch(() => { this._rest = false; });
  }
  sync() {
    const sl = this.slides();
    if (!this.track || !sl.length) return;
    const x = this.track.scrollLeft;
    let best = 0, bd = Infinity;
    sl.forEach((s, i) => { const d = Math.abs(s.offsetLeft - sl[0].offsetLeft - x); if (d < bd) { bd = d; best = i; } });
    if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2) best = sl.length - 1;
    this.idx = best;
    this.querySelectorAll('[data-sk-sn-dot]').forEach((d, i) => d.classList.toggle('is-active', i === best));
    const c = this.querySelector('[data-sk-sn-count]');
    if (c) c.textContent = `${best + 1} ${this.dataset.of || '/'} ${sl.length}`;
    const p = this.querySelector('[data-sk-sn-prev]'), n = this.querySelector('[data-sk-sn-next]');
    if (p) p.disabled = best === 0;
    if (n) n.disabled = best === sl.length - 1;
  }
  go(i, instant) {
    const sl = this.slides();
    if (!this.track || !sl.length) return;
    const k = Math.max(0, Math.min(sl.length - 1, i));
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollTo({ left: sl[k].offsetLeft - sl[0].offsetLeft, behavior: instant || reduce ? 'auto' : 'smooth' });
    this.idx = k;
    if (instant) this.sync();
  }
}
if (!customElements.get('sk-snocks-bundles')) customElements.define('sk-snocks-bundles', SkSnocksBundles);

/* Thumbnail-Leiste (Philipp 31.10.2026): bei 1–2 Treffern mit Shopify-Empfehlungen (related) auffüllen – feste Leistenhöhe,
   daher kein CLS; Klicks zählen (skTrack k:'strip' e:'click', zusätzlich dataLayer sk_strip_click). */
(function () {
  const strip = document.querySelector('[data-sk-strip]');
  if (!strip) return;
  const pid = strip.dataset.pid;
  strip.addEventListener('click', (e) => {
    const a = e.target instanceof Element ? e.target.closest('[data-sk-strip-pid]') : null;
    if (!a) return;
    try { if (window.skTrack) window.skTrack({ k: 'strip', e: 'click', p: pid, t: a.dataset.skStripPid }); } catch (_) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'sk_strip_click', product_id: pid, target_id: a.dataset.skStripPid }); } catch (_) {}
  });
  const url = strip.dataset.fillUrl;
  if (!url) return;
  const list = strip.querySelector('.sk-snocks-strip__list');
  fetch(url).then((r) => (r.ok ? r.text() : '')).then((html) => {
    if (!html || !list) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const have = new Set(Array.from(list.children).map((li) => li.dataset.productId).concat([pid]));
    for (const li of doc.querySelectorAll('[data-sk-strip-recs] > li')) {
      if (list.children.length >= 8) break;
      if (have.has(li.dataset.productId)) continue;
      have.add(li.dataset.productId);
      list.appendChild(document.importNode(li, true));
    }
  }).catch(() => {});
})();

/* „Ähnliche Produkte“ (CLS-Fix 31.10.2026): Skelett-Karten gegen echte Karten tauschen, ohne Höhenänderung.
   Keine Empfehlungen → Platz unsichtbar halten und erst zuklappen, wenn die Section unterhalb des Viewports liegt. */
class SkSnocksLazy extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;
    const go = () => this.load();
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); go(); } }, { rootMargin: '800px 0px' });
      io.observe(this);
    } else go();
  }
  load() {
    const url = this.dataset.url;
    if (!url) return;
    fetch(url).then((r) => (r.ok ? r.text() : '')).then((html) => {
      const doc = new DOMParser().parseFromString(html || '', 'text/html');
      const fresh = doc.querySelector('.sk-snocks-similar__fresh .sk-snocks-similar__row');
      const row = this.querySelector('[data-sk-lazy-row]');
      if (fresh && row && fresh.querySelector('.sk-pdp-card')) {
        row.innerHTML = fresh.innerHTML;
        this.removeAttribute('aria-busy');
        return;
      }
      this.empty();
    }).catch(() => this.empty());
  }
  empty() {
    this.classList.add('is-empty');
    this.removeAttribute('aria-busy');
    const collapse = () => { this.style.display = 'none'; };
    const below = () => this.getBoundingClientRect().top > window.innerHeight;
    if (below()) { collapse(); return; }
    /* erst zuklappen, wenn der Nutzer wieder oberhalb ist (Section unterhalb des Viewports) */
    const onScroll = () => { if (below()) { window.removeEventListener('scroll', onScroll); collapse(); } };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
}
if (!customElements.get('sk-snocks-lazy')) customElements.define('sk-snocks-lazy', SkSnocksLazy);
